import { getUrl, Request } from "../../request";

import firstBanner from "../../../assets/images/base/banners/01.png";
import secondBanner from "../../../assets/images/base/banners/02.png";
import thirdBanner from "../../../assets/images/base/banners/03.jpg";

export const getSliders = (
  city_id,
  category_id,
  mobile,
  location = "main_page"
) => {
  const query = {
    city_id,
    category_id,
    location,
  };
  if (mobile) {
    query["mobile"] = 1;
  } else {
    query["desktop"] = 1;
  }
  if (location === "category_page") {
    return new Promise((resolve, reject) => { 
      resolve({
        success: true,
        data: [],
        code: 200
      })
     })
  }
  return new Promise((resolve) => {
    resolve({
      success: true,
      data: [{
        "id": 2830,
        "type": "banner",
        "label": null,
        "image": firstBanner,
        "image_2": null,
        "color": null,
        "use_details": false,
        "use_details_2": false,
        "url": "",
        "url_2": "",
        "product": null,
        "product_2": null,
        "external_url": false,
        "external_url_2": false
      }, {
        "id": 2820,
        "type": "banner",
        "label": null,
        "image": secondBanner,
        "image_2": null,
        "color": null,
        "use_details": false,
        "use_details_2": false,
        "url": "",
        "url_2": "",
        "product": null,
        "product_2": null,
        "external_url": false,
        "external_url_2": false
      }, {
        "id": 2810,
        "type": "banner",
        "label": null,
        "image": thirdBanner,
        "image_2": null,
        "color": null,
        "use_details": false,
        "use_details_2": false,
        "url": "",
        "url_2": "",
        "product": null,
        "product_2": null,
        "external_url": false,
        "external_url_2": false
      },],
      code: 200
    })
  })
  // return Request.get(getUrl("/api/v1/content/slider/"), query);
};

export const getFaqs = () => {
  return Request.get(getUrl("/api/v1/content/faq"));
};
